import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useStoreContext } from 'store/app';
import cn from 'classnames';
import { ToastTypes } from 'src/types';
import { InfoIcon, SuccessIcon } from 'components/icons';

import './Toast.styl';

export const toastVisibleDuration = 3000;

export const Toast = observer(() => {
    const { toastConfig, setToastConfig } = useStoreContext();

    const [showToast, setShowToast] = useState(false);

    useEffect(() => {
        if (toastConfig) {
            setShowToast(true);
            setTimeout(() => {
                setShowToast(false);
                setTimeout(() => {
                    setToastConfig(undefined);
                }, 1000);
            }, toastVisibleDuration);
        }
    }, [toastConfig]);

    const toastIcon = useMemo(() => {
        if (toastConfig?.type === ToastTypes.SUCCESS) {
            return <SuccessIcon />;
        }
        if (toastConfig?.type === ToastTypes.ERROR) {
            return <InfoIcon />;
        }

        return <SuccessIcon />;
    }, [toastConfig]);

    return (
        <div className={cn('toast', { visible: showToast })}>
            <span className="toast-icon">{toastIcon}</span>
            <div className="toast-text">{toastConfig?.text}</div>
        </div>
    );
});
